/**
 * weiboSignOperationBtnsModule
 * description: weibo渠道下操作按钮
 * author: Qian.qianchen 2019-03-26
 */
'use strict';
angular.module('weiboSignOperationBtnsModule', []).directive('weiboSignOperationBtns', [
    'modalDialog',
    'trsHttpService',
    'editingCenterWeiBoService',
    function(modalDialog, trsHttpService, editingCenterWeiBoService) {
        return {
            restrict: 'E',
            replace: false,
            templateUrl: './editingCenter/iWo/fusionSign/directive/weiboSignOperationBtns/weiboSignOperationBtns_tpl.html',
            scope: {
                selectedArr: '=',
                callback: '&',
            },
            link: function($scope, iElement, attrs) {

                /**
                 * [trial description] 微博撤稿
                 * @return {[type]}      [description]
                 */
                $scope.withdraw = function() {
                    if ($scope.selectedArr.length > 1) {
                        modalDialog.alertType('融合审签微博撤稿每次只能操作一篇稿件', '', 'warning', false);
                        return;
                    }
                    editingCenterWeiBoService.withdrawWeibo($scope.selectedArr, function(result) {
                        if (result[0].CODE == -1) {
                            modalDialog.alertType('', result[0].MSG, 'error', 'confirm');
                        } else {
                            modalDialog.alertType('撤稿成功', '', 'success', false);
                            $scope.callback();
                        }
                    });
                };

                /**
                 * [directSign description] 直接签发
                 * @return {[type]}      [description]
                 */
                $scope.directSign = function() {
                    editingCenterWeiBoService.directSignWeibo($scope.selectedArr, false, '20', function(result) {
                        if (result == 'success') {
                            modalDialog.alertType('直接签发成功', '', 'success', false);
                            $scope.callback();
                        } else {
                            modalDialog.alertType('该微博直接签发失败！', result.result.detail, 'error', 'confirm', function() {});
                        }
                    });
                };
                
                /**
                 * [timeSign description] 定时签发
                 * @return {[type]}      [description]
                 */
                $scope.timeSign = function() {
                    editingCenterWeiBoService.timeSignWeibo($scope.selectedArr, false, '20', function(result) {
                        if (result == 'success') {
                            modalDialog.alertType('定时签发设置成功', '', 'success', false);
                            $scope.callback();
                        } else {
                            modalDialog.alertType('该微博定时签发失败！', result.result.detail, 'error', 'confirm', function() {});
                        }
                    });
                };
            },
        };
    },
]);
